import MDBox from "components/MDBox";
import { Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import moment from "moment";

function RemainingDays({ endDate, expiryStatus }) {
  return (
    <MDBox
      sx={{
        color: expiryStatus.isExpired
          ? "error.main"
          : expiryStatus.severity === "critical"
          ? "error.main"
          : expiryStatus.severity === "warning"
          ? "warning.main"
          : "text.primary",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {endDate}
      {/* hide tooltip if days remaining more than 7 days */}
      <Tooltip
        title={
          expiryStatus.isExpired
            ? `Due in ${expiryStatus.daysRemaining +1} days`
            : expiryStatus.isExpiringSoon
            ? expiryStatus.daysRemaining === 0
              ? `Due today`
              : expiryStatus.daysRemaining === 1
              ? `Due tomorrow`
              : `Due in ${expiryStatus.daysRemaining +1} days`
            : `Due in ${expiryStatus.daysRemaining +1} days`
        }
        arrow
      >
        {/* info icon   */}
        <InfoOutlined
          sx={{
            color: expiryStatus.isExpired
              ? "error.main"
              : expiryStatus.severity === "critical"
              ? "error.main"
              : expiryStatus.severity === "warning"
              ? "warning.main"
              : "text.primary",
          }}
        />
      </Tooltip>
    </MDBox>
  );
}

export default RemainingDays;
